/*
 *
 * Do not edit directly
 * Generated on Mon, 24 Jun 2024 16:18:26 GMT
 *
 */


const theme = {
  appearances: {
    spacing: {
      description: 'Adjusts the height of the table cell',
      type: 'variant',
      values: [ 'compact', 'default' ]
    },
    text: { type: 'variant', values: [ 'small', 'medium' ] },
    type: {
      type: 'variant',
      values: [ 'subHeading', 'rowHeading', 'heading', 'default' ]
    }
  },
  rules: [
    {
      if: { spacing: 'compact', type: 'default' },
      tokens: {
        cellPaddingBottom: 8,
        cellPaddingTop: 8,
        fontSize: 16,
        lineHeight: 1.25
      }
    },
    {
      if: { spacing: 'compact', type: 'rowHeading' },
      tokens: {
        cellPaddingBottom: 8,
        cellPaddingTop: 8,
        fontName: 'HelveticaNow',
        fontSize: 16,
        fontWeight: '700',
        lineHeight: 1.25
      }
    },
    {
      if: { spacing: 'compact', text: 'small', type: 'subHeading' },
      tokens: {
        cellBackground: '#fafafa',
        cellPaddingBottom: 8,
        cellPaddingTop: 8,
        fontName: 'HelveticaNow',
        fontSize: 14,
        fontWeight: '500',
        lineHeight: 1.14285714286
      }
    },
    {
      if: { type: 'heading' },
      tokens: {
        cellBackground: '#f4f4f7',
        cellBoxShadowColor: '#b2b9bf',
        fontName: 'HelveticaNow',
        fontSize: 16,
        fontWeight: '500'
      }
    },
    {
      if: { spacing: 'default', type: 'subHeading' },
      tokens: {
        cellBackground: '#fafafa',
        fontName: 'HelveticaNow',
        fontSize: 14,
        fontWeight: '500',
        lineHeight: 1.28571428571
      }
    },
    {
      if: { spacing: 'compact', text: 'medium', type: 'subHeading' },
      tokens: {
        cellBackground: '#fafafa',
        fontName: 'HelveticaNow',
        fontSize: 16,
        fontWeight: '500',
        lineHeight: 1.25
      }
    },
    {
      if: { spacing: 'default', type: 'rowHeading' },
      tokens: { fontName: 'HelveticaNow', fontSize: 16, fontWeight: '700' }
    },
    {
      if: { spacing: 'default', text: 'small', type: 'default' },
      tokens: {
        fontName: 'HelveticaNow',
        fontSize: 14,
        fontWeight: '400',
        lineHeight: 1.42857142857
      }
    },
    {
      if: { spacing: 'compact', text: 'small', type: 'default' },
      tokens: {
        fontName: 'HelveticaNow',
        fontSize: 14,
        fontWeight: '400',
        lineHeight: 1.14285714286
      }
    },
    {
      if: { text: 'small', type: 'rowHeading' },
      tokens: {
        fontName: 'HelveticaNow',
        fontSize: 14,
        fontWeight: '700',
        lineHeight: 1.14285714286
      }
    }
  ],
  tokens: {
    borderColor: 'rgba(0, 0, 0, 0)',
    borderWidth: 0,
    cellBackground: 'rgba(0, 0, 0, 0)',
    cellBoxShadowColor: '#e3e6e8',
    cellMinWidth: 0,
    cellPaddingBottom: 16,
    cellPaddingLeft: 16,
    cellPaddingRight: 16,
    cellPaddingTop: 16,
    cellStickyShadow: {
      blur: 8,
      color: 'rgba(0, 0, 0, 0.1)',
      inset: false,
      offsetX: 0,
      offsetY: 4,
      spread: 0
    },
    display: null,
    fontColor: '#000000',
    fontName: 'HelveticaNow',
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 1.5,
    stickyBackgroundColor: '#ffffff',
    tablePaddingBottom: 24
  }
}
export default theme
